/* Native anchors and the request form remain usable without JavaScript. */
(() => {
  function initialize(scope) {
    scope.querySelectorAll('[data-mct-displays]').forEach((root) => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      root.addEventListener('click', (event) => {
        const link = event.target.closest('[data-display-select]');
        if (!link || !root.contains(link) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const select = root.querySelector('[data-display-choice]');
        const option = Array.from(select?.options || []).find((item) => item.dataset.displayId === link.dataset.displaySelect);
        if (option) {
          select.value = option.value;
          select.dispatchEvent(new Event('change', {bubbles: true}));
        }
      });
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
